import { render, staticRenderFns } from "./xnblist.vue?vue&type=template&id=21b0b1d4&scoped=true&"
import script from "./xnblist.vue?vue&type=script&lang=js&"
export * from "./xnblist.vue?vue&type=script&lang=js&"
import style0 from "./xnblist.vue?vue&type=style&index=0&id=21b0b1d4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b0b1d4",
  null
  
)

export default component.exports